var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import { GridColumnMenuFilterCell } from './GridColumnMenuFilterCell';
import { DropDownList } from '@progress/kendo-react-dropdowns';
/**
 * @hidden
 */
var GridColumnMenuFilterUI = /** @class */ (function (_super) {
    __extends(GridColumnMenuFilterUI, _super);
    function GridColumnMenuFilterUI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridColumnMenuFilterUI.prototype.render = function () {
        var _a = this.props, firstFilterProps = _a.firstFilterProps, hideSecondFilter = _a.hideSecondFilter, secondFilterProps = _a.secondFilterProps, logicData = _a.logicData, logicValue = _a.logicValue, onLogicChange = _a.onLogicChange, operators = _a.operators;
        return (React.createElement("div", null,
            React.createElement(GridColumnMenuFilterCell, __assign({}, firstFilterProps, { operators: operators })),
            !hideSecondFilter && (React.createElement("div", null,
                React.createElement(DropDownList, { data: logicData, value: logicValue, onChange: onLogicChange, className: 'k-filter-and', textField: "text" }),
                React.createElement(GridColumnMenuFilterCell, __assign({}, secondFilterProps, { operators: operators }))))));
    };
    return GridColumnMenuFilterUI;
}(React.Component));
export { GridColumnMenuFilterUI };
//# sourceMappingURL=GridColumnMenuFilterUI.js.map